module.exports = __webpack_public_path__ + "media/images/brand/cross-blue-880acc67fdbb6aefeac56ea1c4818a79.svg";